/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type ReactNode } from "react";

import { jsx } from "@compiled/react";

import { Box, xcss } from "@atlaskit/primitives";

const formFooterStyles = xcss({
    marginBlockStart: "space.200"
});

type FormFooterProps = {
    children: ReactNode;
};

export const FormFooter = ({ children }: FormFooterProps) => {
    return <Box xcss={formFooterStyles}>{children}</Box>;
};
